import React from 'react'
import useQueryExchanges from '../../../hooks/etc/useQueryExchanges'
import Text from '../../../components/text/Text'
import WizImage from '../../../components/image/WizImage'
import {useString} from '../../../utils/string'
import {useDisplayNumber} from '../../../utils/number'
import {useTag} from '../../../utils/etc'
import {IUserData} from '../../../apis/user/getUserDetail'
import useNavigation from '../../../hooks/useNavigation'

interface IProps {
    className?: string
    data?: IUserData
}

const UserApiContainer: React.FC<IProps> = ({className, data}) => {
    const {data: exchanges} = useQueryExchanges()
    const {shortCutString} = useString()
    const {floorBalance} = useDisplayNumber()
    const {goKeyDetail} = useNavigation()
    const {renderStateColor} = useTag()

    return (
        <div className={`bg-white h-full rounded-[10px] p-[30px] shadow-normal ${className}`}>
            <Text className={'text-h3'}>API Key</Text>
            <div className={'mt-[10px]'}>
                {data?.Keys?.map((item, idx) => (
                    <div key={idx} className={'border-t border-line03 py-[15px] first:border-none'}>
                        <div
                            className={'hover:bg-bg_gray01 cursor-pointer p-[5px] rounded-[5px]'}
                            onClick={() => goKeyDetail(item?.key_id)}>
                            <div className={'flex space-x-[10px] items-center'}>
                                <div className={'flex-none'}>
                                    <WizImage
                                        src={exchanges?.find(exchange => exchange?.name === item?.exchange)?.icon}
                                        className={'w-[36px]'}
                                    />
                                </div>
                                <div className={'flex items-center justify-between w-full'}>
                                    <div>
                                        <Text className={'text-ti1'}>{item?.name ? item.name : '[No API Name]'}</Text>
                                        <Text className={'text-body3 text-font03'}>
                                            ({shortCutString(item?.api_key)})
                                        </Text>
                                    </div>
                                    <div className={'flex flex-col items-end space-y-[3px]'}>
                                        <Text className={`text-right ${renderStateColor(item?.is_active)}`}>
                                            {item?.is_active ? 'Active' : 'Stopped'}
                                        </Text>
                                        <Text className={`text-right text-ti2`}>{floorBalance(item?.balance)}</Text>
                                    </div>
                                </div>
                            </div>
                            <div className={'flex items-center justify-between text-center mt-[15px]'}>
                                <div className={'flex-1'}>
                                    <Text className={'text-ti3 text-font02'}>Ip Set</Text>
                                    <Text
                                        className={`text-ti1 ${
                                            item?.ip_set === 'set' ? 'text-primary' : 'text-font_red'
                                        }`}>
                                        {item?.ip_set || '-'}
                                    </Text>
                                </div>
                                <div className={'flex-1'}>
                                    <Text className={'text-ti3 text-font02'}>Pro Ip Set</Text>
                                    <Text
                                        className={`text-ti1 ${
                                            item?.pro_ip_set === 'set' ? 'text-primary' : 'text-font_red'
                                        }`}>
                                        {item?.pro_ip_set || '-'}
                                    </Text>
                                </div>
                                {item?.exchange === 'bithumb' && (
                                    <div className={'flex-1'}>
                                        <Text className={'text-ti3 text-font02'}>Ip Type</Text>
                                        <Text className={`text-ti1 `}>{item?.type}</Text>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default UserApiContainer
